<mat-menu #objMenu="matMenu">
  <button mat-menu-item enabled (click)="setSelectedObj(null)">
    <mat-icon>search_off</mat-icon>
    <span style="font-size: 0.9em">Clear Selection</span>
  </button>
  <button mat-menu-item enabled (click)="refreshList()">
    <mat-icon>refresh</mat-icon>
    <span style="font-size: 0.9em">Refresh List</span>
  </button>
  <button *ngIf="iam && userData.iam" mat-menu-item (click)="createObj()">
    <mat-icon>add</mat-icon>
    <span style="font-size: 0.9em">Add New Company/Org.</span>
  </button>
  <button
    *ngIf="selectedObj && (isObjAdmin || (iam && userData.iam))"
    mat-menu-item
    disabled="{{ !selectedObj }}"
    (click)="editObj()"
  >
    <mat-icon>edit</mat-icon>
    <span style="font-size: 0.9em">Edit Company/Org. Info</span>
  </button>
  <button
    *ngIf="selectedObj"
    mat-menu-item
    disabled="{{ !selectedObj }}"
    (click)="viewObj()"
  >
    <mat-icon>domain</mat-icon>
    <span style="font-size: 0.9em">View Company/Org. Info</span>
  </button>
  <!---
   <button *ngIf="userData.iam"
	  mat-menu-item disabled (click)="deleteOrg()">
    <mat-icon>delete</mat-icon>
    <span style="font-size: 0.9em">Delete Company/Org.</span>
  </button>
   --->
</mat-menu>

<mat-menu #listViewMenu="matMenu">
  <button mat-menu-item enabled (click)="setMode(DisplayMode.COMBO)">
    <mat-icon>input</mat-icon>
    <span style="font-size: 0.9em">Combo Select</span>
  </button>
  <button mat-menu-item enabled (click)="setMode(DisplayMode.SELECT)">
    <mat-icon>arrow_drop_down</mat-icon>
    <span style="font-size: 0.9em">Select</span>
  </button>
  <button mat-menu-item enabled (click)="setMode(DisplayMode.SELECT_LIST)">
    <mat-icon>view_list</mat-icon>
    <span style="font-size: 0.9em">Select List</span>
  </button>
  <button
    mat-menu-item
    enabled
    (click)="setMode(DisplayMode.TABLE); refreshList()"
  >
    <mat-icon>table_rows_narrow</mat-icon>
    <span style="font-size: 0.9em">Table</span>
  </button>
</mat-menu>

<mat-menu #rowMenu="matMenu">
  <ng-template matMenuContent let-obj="obj">
    <button mat-menu-item (click)="setSelectedObj(obj); viewObj()">
      <mat-icon>domain</mat-icon>
      <span style="font-size: 0.9em">View Info</span>
    </button>
    <!--      *ngIf="getIsObjAdmin(obj, userData)" -->
    <button
      *ngIf="selectedObj && (isObjAdmin || (iam && userData.iam))"
      mat-menu-item
      (click)="setSelectedObj(obj); editObj()"
    >
      <mat-icon>edit</mat-icon>
      <span style="font-size: 0.9em">Edit {{ objLabel }}</span>
    </button>
  </ng-template>
</mat-menu>

<mat-menu #objListMenu="matMenu">
  <button mat-menu-item enabled (click)="setSelectedObj(null)">
    <mat-icon>search_off</mat-icon>
    <span style="font-size: 0.9em">Clear Selection</span>
  </button>
  <button mat-menu-item enabled (click)="refreshList()">
    <mat-icon>refresh</mat-icon>
    <span style="font-size: 0.9em">Refresh List</span>
  </button>
  <!-- *ngIf="userData.iam" -->
  <button
    *ngIf="isObjAdmin || (iam && userData.iam)"
    mat-menu-item
    (click)="createObj()"
  >
    <mat-icon>add</mat-icon>
    <span style="font-size: 0.9em">Add {{ objLabel }}</span>
  </button>
  <button
    *ngIf="selectedObj && (isObjAdmin || (iam && userData.iam))"
    mat-menu-item
    disabled="{{ !selectedObj }}"
    (click)="editObj()"
  >
    <mat-icon>edit</mat-icon>
    <span style="font-size: 0.9em">Edit {{ objLabel }}</span>
  </button>
  <button
    *ngIf="selectedObj && selectedObj !== null"
    mat-menu-item
    disabled="{{ !selectedObj }}"
    (click)="viewObj()"
  >
    <mat-icon>domain</mat-icon>
    <span style="font-size: 0.9em">View {{ objLabel }}</span>
  </button>
  <!---
   <button *ngIf="userData && userData.uid && selectedObj && (selectedObj['owner']===userData.uid)"
	  mat-menu-item (click)="deleteObj()">
    <mat-icon>delete</mat-icon>
    <span style="font-size: 0.9em">Delete {{objLabel}}</span>
  </button>
    --->
</mat-menu>

<ng-template #hidden> </ng-template>

<ng-template #objSelect>
  <div style="display: flex; flex-flow: row; min-width: 60vw">
    <mat-select
      class="org-select"
      style="
        z-index: 900;
        color: #2274a5;
        font-size: 1em;
        width: 80%;
        border-bottom: 2px solid #2274a5;
        margin-left: 1rem;
        margin-right: 1rem;
        min-width: 50vw;
      "
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="selectedObj"
      [compareWith]="compareObjs"
      placeholder="Select {{ objLabel }}"
      ngDefaultControl
      selected="selectedObj"
      (selectionChange)="setSelectedObj(selectedObj)"
    >
      <mat-select-trigger>
        <mat-icon
          matPrefix
          *ngIf="selectedObj && selectedObj.uid"
          style="margin-right: 1rem"
          >domain</mat-icon
        >
        <span *ngIf="selectedObj">
          {{ selectedObj.org_name ? selectedObj.org_name : "" }}
        </span>
      </mat-select-trigger>
      <mat-option
        id="no_org"
        style="color: blue; font-size: 1em"
        [value]="null"
        style="color: #2274a5; :font-size: 1em"
        >None</mat-option
      >
      <mat-option
        *ngFor="let o of orgsvc.orgList$ | async"
        [value]="o"
        style="color: #2274a5; :font-size: 1em"
      >
        <mat-icon matPrefix *ngIf="o && o.uid" style="margin-right: 1rem"
          >domain</mat-icon
        >
        {{ o["org_name"] ? o["org_name"] : "" }}
      </mat-option>
    </mat-select>
    <button
      mat-stroked-button
      (click)="setTemplate(DisplayTemplate.LIST)"
      style="width: 0.8em; margin-right: 0.4em; color: #2274a5"
    >
      <mat-icon style="width: 0.8em; color: #2274a5">search</mat-icon>
    </button>
    <!-- 		 *ngIf="userData.iam" -->
    <button
      *ngIf="userData.iam && iam"
      mat-stroked-button
      (click)="createObj()"
      style="width: 0.8em; margin-right: 0.4em; color: #2274a5"
    >
      <mat-icon style="width: 0.8em; color: #2274a5">add</mat-icon>
    </button>
    <button
      *ngIf="selectedObj !== null && showMenuButton"
      mat-stroked-button
      [matMenuTriggerFor]="objListMenu"
      style="width: 0.8em; margin-right: 0.4em; color: #2274a5"
    >
      <mat-icon style="width: 0.8em; color: #2274a5">more_vert</mat-icon>
    </button>
    <button
      *ngIf="showListViewButton"
      mat-stroked-button
      [matMenuTriggerFor]="listViewMenu"
      style="width: 0.8em; margin-right: 0.4em; color: #2274a5"
    >
      <mat-icon style="width: 0.8em; height: 1em; color: #2274a5"
        >list</mat-icon
      >
    </button>
  </div>
</ng-template>

<!-- for input [formControl]="myControl" -->
<!-- (input)="onOrgNameChange($event)" 
       (input)="onOrgNameChange($event)"
	   name="orgNameInput"
              (optionChange)="setSelectedOrg(selectedOrg)"
	      [ngClass]="(orgNameInput.value===org.org_name)?'mat-selecte-default':''"
  -->
<ng-template #objCombo>
  <div style="display: flex; flex-flow: row; min-width: 60vw">
    <form class="combo-form" [formGroup]="comboForm">
      <mat-form-field
        class="combo-form-field"
        (click)="clearComboInput()"
        [appearance]="formFieldStyle"
        [floatLabel]="'always'"
        style="font-size: 0.8rem; min-width: 50vw"
      >
        <mat-label class="form-label">{{ objLabel }} Name</mat-label>
        <mat-icon matPrefix style="margin-right: 1rem">domain</mat-icon>
        <input
          #objName
          matInput
          type="text"
          placeholder="Enter or Select Name"
          style="font-size: 1rem"
          [formControl]="objNameInput"
          aria-label="Company/Org. Name"
          [matAutocomplete]="autoCombo"
        />
        <mat-autocomplete
          #autoCombo="matAutocomplete"
          (optionSelected)="setSelectedObjEvent($event)"
          placeholder="Company/Org."
        >
          <ng-container *ngIf="showNoneOption">
            <mat-option [value]="null">NONE</mat-option>
          </ng-container>
          <div *ngFor="let obj of orgsvc.orgList$ | async">
            <mat-option
              *ngIf="obj.org_name.includes(objName.value)"
              [value]="obj"
              [id]="obj.uid"
            >
              <mat-icon matPrefix style="margin-right: 1rem">domain</mat-icon>
              {{ obj.org_name ? obj.org_name : "" }}
            </mat-option>
          </div>
        </mat-autocomplete>

        <!-- {{(obj.org_user_email===userInfo.email) ? '&#9733;' : ''}}	  -->
        <!--              <span *ngIf="obj.org_owner_email && obj.org_owner_email===userInfo.email" style="font-size: 0.8rem"> &#9733;</span>	      	      -->

        <button matSuffix (click)="clearComboInput()" style="margin-left: 1rem">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
      </mat-form-field>
    </form>
    <div
      #comboButtonDiv
      class="combo-button-div"
      style="display: flex; flex-flow: row nowrap; align-items: center"
    >
      <button
        *ngIf="showAddButton && userData.iam && iam"
        mat-stroked-button
        (click)="createObj()"
        style="
          margin-left: 0.7rem;
          margin-right: 0.7rem;
          margin-top: -0.7rem;
          height: 3rem;
        "
      >
        <mat-icon style="">domain_add</mat-icon>
      </button>
      <button
        *ngIf="selectedObj !== null && showMenuButton"
        mat-stroked-button
        [matMenuTriggerFor]="objListMenu"
        style="
          margin-left: 0.7rem;
          margin-right: 0.7rem;
          margin-top: -0.7rem;
          height: 3rem;
        "
      >
        <mat-icon style="">more_vert</mat-icon>
      </button>
      <button
        *ngIf="showListViewButton"
        mat-stroked-button
        [matMenuTriggerFor]="listViewMenu"
        style="
          margin-left: 0.7rem;
          margin-right: 0.7rem;
          margin-top: -0.7rem;
          height: 3rem;
        "
      >
        <mat-icon style="">list</mat-icon>
      </button>
    </div>
  </div>
</ng-template>

<!-- SELECT_ORG TEMPLATE -->
<div
  *ngIf="template === DisplayTemplate.SELECT"
  style="
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: stretch;
    width: 100%;
  "
>
  <ng-container *ngTemplateOutlet="objSelect"> </ng-container>
</div>
<!-- END SELECT_ORG Template  -->

<!-- COMBO TEMPLATE -->
<div
  *ngIf="template === DisplayTemplate.COMBO"
  style="
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: stretch;
    width: 100%;
  "
>
  <ng-container *ngTemplateOutlet="objCombo"> </ng-container>
</div>
<!-- END COMBO Template  -->

<div #orgList *ngIf="template === DisplayTemplate.LIST">
  <mat-list>
    <div
      style="
        display: flex;
        flex-flow: row;
        justify-content: space-around;
        align-items: center;
      "
    >
      <mat-form-field
        *ngIf="showTitleFilter"
        class="mat-header-row"
        style="font-size: 0.75rem; margin-left: 2em; margin-right: 0.5em"
      >
        <input
          matInput
          #titleFilterInput
          [(ngModel)]="titleFilter"
          type="text"
          style="width: 60%; font-size: 1rem"
          placeholder="Enter Search filter"
        />
      </mat-form-field>
      <button
        *ngIf="showSelectButton"
        mat-stroked-button
        style="margin-top: -1em; background-color: #2274a5; color: white"
        (click)="onDone()"
      >
        Done
      </button>
      <!-- style="margin-top: -1em; background-color: #2274A5; color: white" -->
      <button
        *ngIf="userData.iam && iam"
        mat-stroked-button
        style="margin-top: -1em; margin-left: 2em"
        (click)="createObj()"
      >
        <mat-icon>add</mat-icon>
      </button>
      <button
        *ngIf="selectedObj !== null && showMenuButton"
        mat-stroked-button
        style="margin-top: -1em; margin-left: 2em"
        [matMenuTriggerFor]="objListMenu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <button
        *ngIf="showListViewButton"
        mat-stroked-button
        [matMenuTriggerFor]="listViewMenu"
        style="
          margin-left: 0.7rem;
          margin-right: 0.7rem;
          margin-top: -0.7rem;
          height: 3rem;
        "
      >
        <mat-icon style="">list</mat-icon>
      </button>
    </div>

    <div style="margin-bottom: 200px; scroll: none">
      <div
        *ngFor="
          let obj of orgsvc.orgList$
            | async
            | filterkeys: ['org_name'] : titleFilter
            | sortkey: 'org_name' : 'asc'
        "
        style="
          display: flex;
          flex-flow: column;
          justify-content: space-beteen;
          width: 100%;
          color: black;
          scroll: auto;
        "
      >
        <mat-divider style="min-width: 100%"></mat-divider>
        <app-org
          #objListItem
          style="width: 100%"
          [iam]="iam"
          [isObjAdmin]="isObjAdmin"
          [mode]="objMode"
          [userInfo]="userInfo"
          [userData]="userData"
          [objData]="obj"
          [selectedObj]="selectedObj"
          [showActions]="showActions"
          [useMenuActionDialog]="useMenuActionDialog"
          (modeEvent)="setMode($event)"
          (refreshEvent)="refreshList()"
          (selectObjEvent)="setSelectedObj($event)"
          (submitEvent)="onDone()"
          (editObjEvent)="editObj()"
          (cancelEvent)="onDone()"
        >
        </app-org>

        <!--       
       <mat-list-item *ngIf="selectedObj && (obj.uid===selectedObj.uid); else unSelectedItem"
	 style="display: flex; flex-flow: row; justify-content: space-between; background: #2274A5; color: white;" (click)="setSelectedObj(obj)">
	 <span style="margin-left: 1rem; width: 95%;">{{obj['name']}}</span>
         <span *ngIf="userData && userData.uid===obj.owner" style="font-size: 0.8rem; justify-content: space-between;"> &#9733;</span>
       </mat-list-item>		      
       <ng-template #unSelectedItem>
	 <mat-list-item
	 style="display: flex; flex-flow: row; justify-content: space-between; width: 100%; background: white; color: #2274A5" (click)="setSelectedObj(obj);">
	 <span style="margin-left: 1rem">{{obj['name']}}</span>
         <span *ngIf="userData && userData.uid===obj.owner" style="font-size: 0.8rem"> &#9733;</span>	 
       <mat-icon *ngIf="selectedObj && (obj.uid===selectedObj.uid)"
		 style="align: end; align-self: center; margin-left: 0.4em; margin-right: 0.5em; color: #2274A5">
	         check
       </mat-icon>
       </mat-list-item>
       </ng-template>
       -->
        <mat-divider [inset]="true"></mat-divider>
      </div>
    </div>
    <mat-divider style="color: gray; min-width: 100%"></mat-divider>
  </mat-list>
  <div class="list-bottom-div">
    <div class="list-btn-div">
      <button mat-stroked-button class="submit-btn" (click)="onDone()">
        Done
      </button>
    </div>
  </div>
</div>

<div #grpList *ngIf="template === DisplayTemplate.SELECT_LIST">
  <mat-list>
    <div
      style="
        display: flex;
        flex-flow: row;
        justify-content: space-around;
        align-items: center;
      "
    >
      <mat-form-field
        *ngIf="showTitleFilter"
        class="mat-header-row"
        style="font-size: 0.75rem; margin-left: 2em; margin-right: 0.5em"
      >
        <input
          matInput
          #titleFilterInput
          [(ngModel)]="titleFilter"
          type="text"
          style="width: 60%; font-size: 1rem"
          placeholder="Enter Search filter"
        />
      </mat-form-field>
      <button
        *ngIf="showSelectButton"
        mat-stroked-button
        style="margin-top: -1em; background-color: #2274a5; color: white"
        (click)="onDone()"
      >
        Done
      </button>
      <!-- style="margin-top: -1em; background-color: #2274A5; color: white" -->
      <button
        *ngIf="iam && userData.iam"
        mat-stroked-button
        style="margin-top: -1em; margin-left: 2em"
        (click)="createObj()"
      >
        <mat-icon>add</mat-icon>
      </button>
      <button
        *ngIf="showRefreshButton"
        mat-stroked-button
        style="margin-top: -1em; margin-left: 2em"
        (click)="refreshList()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <button
        *ngIf="selectedObj !== null && showMenuButton"
        mat-stroked-button
        style="margin-top: -1em; margin-left: 2em"
        [matMenuTriggerFor]="objListMenu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <button
        *ngIf="showListViewButton"
        mat-stroked-button
        [matMenuTriggerFor]="listViewMenu"
        style="
          margin-left: 0.7rem;
          margin-right: 0.7rem;
          margin-top: -0.7rem;
          height: 3rem;
        "
      >
        <mat-icon style="">list</mat-icon>
      </button>
    </div>

    <div
      *ngFor="
        let obj of orgsvc.orgList$
          | async
          | filterkeys: ['name'] : titleFilter
          | sortkey: 'name' : 'asc'
      "
      style="
        display: flex;
        flex-flow: column;
        justify-content: space-beteen;
        width: 100%;
        color: black;
      "
    >
      <mat-divider style="min-width: 100%"></mat-divider>
      <app-org
        #objListItem
        style="width: 100%"
        [iam]="iam"
        [isObjAdmin]="isObjAdmin"
        [mode]="objMode"
        [userInfo]="userInfo"
        [userData]="userData"
        [objData]="obj"
        [selectedObj]="selectedObj"
        [showActions]="showActions"
        [useMenuActionDialog]="useMenuActionDialog"
        [showMenuButton]="showMenuButton"
        [showDeleteButton]="showDeleteButton"
        (modeEvent)="setMode($event)"
        (refreshEvent)="refreshList()"
        (selectObjEvent)="setSelectedObj($event)"
        (editObjEvent)="editObj()"
        (doneEvent)="onDone()"
        (cancelEvent)="onDone()"
      >
      </app-org>
      <mat-divider [inset]="true"></mat-divider>
    </div>
    <mat-divider style="color: gray; min-width: 100%"></mat-divider>
  </mat-list>
  <div class="list-bottom-div">
    <div class="list-btn-div">
      <button mat-stroked-button class="submit-btn" (click)="onDone()">
        Done
      </button>
    </div>
  </div>
</div>

<div *ngIf="template === DisplayTemplate.FORM">
  <div *ngIf="showObjSelect">
    <ng-container *ngTemplateOutlet="objSelect"> </ng-container>
  </div>
  <mat-divider></mat-divider>
  <mat-list>
    <div>
      <app-org
        #objFormItem
        style="width: 100%"
        [iam]="iam"
        [isObjAdmin]="isObjAdmin"
        [mode]="objMode"
        [userInfo]="userInfo"
        [userData]="userData"
        [objData]="selectedObj"
        [selectedObj]="selectedObj"
        [showActions]="showActions"
        [useMenuActionDialog]="useMenuActionDialog"
        (modeEvent)="setMode($event)"
        (prevEvent)="prevObj()"
        (nextEvent)="nextObj()"
        (refreshEvent)="refreshList()"
        (selectObjEvent)="setSelectedObj($event)"
        (editObjEvent)="editObj()"
        (submitEvent)="onSubmit($event)"
        (cancelEvent)="onDone()"
      >
      </app-org>
      <mat-divider [inset]="true"></mat-divider>
    </div>
    <mat-divider style="color: gray; min-width: 100%"></mat-divider>
  </mat-list>
</div>

<!-- ORG_LIST -->

<div *ngIf="template === DisplayTemplate.TABLE">
  <div
    style="
      display: flex;
      flex-flow: row;
      justify-content: space-around;
      align-items: center;
    "
  >
    <mat-form-field
      *ngIf="showTitleFilter"
      class="mat-header-row"
      style="
        font-size: 0.75rem;
        margin-left: 2em;
        margin-right: 0.5em;
        color: #2274a5;
      "
    >
      <input
        matInput
        #titleFilterInput
        [(ngModel)]="titleFilter"
        type="text"
        (keyup)="applyTableFilter(titleFilterInput.value)"
        style="width: 60%; font-size: 1rem; color: #2274a5"
        placeholder="Enter Search filter"
      />
    </mat-form-field>
    <button
      *ngIf="showSelectButton"
      mat-stroked-button
      style="margin-top: -1em; background-color: #2274a5; color: white"
      (click)="onDone()"
    >
      Done
    </button>
    <!-- style="margin-top: -1em; background-color: #2274A5; color: white" -->
    <button
      *ngIf="iam && userData.iam"
      mat-stroked-button
      style="margin-top: -1em; margin-left: 2em; color: #2274a5"
      (click)="createObj()"
    >
      <mat-icon style="color: 2274A5">add</mat-icon>
      Add {{ objLabel }}
    </button>
    <button
      *ngIf="selectedObj !== null && showMenuButton"
      mat-stroked-button
      [matMenuTriggerFor]="objListMenu"
      style="
        margin-left: 0.7rem;
        margin-right: 0.7rem;
        margin-top: -0.7rem;
        height: 3rem;
      "
    >
      <mat-icon style="">more_vert</mat-icon>
    </button>
    <button
      *ngIf="showMenuButton"
      mat-stroked-button
      [matMenuTriggerFor]="listViewMenu"
      style="
        margin-left: 0.7rem;
        margin-right: 0.7rem;
        margin-top: -0.7rem;
        height: 3rem;
      "
    >
      <mat-icon style="">list</mat-icon>
    </button>
  </div>

  `
  <div class="table-container">
    <mat-table
      #objTable
      [dataSource]="dataSource"
      matSort
      matSortActive="org_name"
      matSortDirection="asc"
      style="
        min-width: 80vw;
        max-width: 95vw;
        max-height: 95vh;
        margin-left: 0.7em;
      "
    >
      <!--   <mat-table #orgTable [dataSource]="this.orgList" style="min-width: 75vw; max-width: 95vw; min-height: 95vh; margin-left: 0.7em">      -->

      <!-- org name Column -->
      <ng-container matColumnDef="org_client_nbr">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          >Client #</mat-header-cell
        >
        <mat-cell
          *matCellDef="let org"
          style="word-wrap: break-word; width: 20%; cursor: default"
          >{{ org.org_client_nbr }}</mat-cell
        >
      </ng-container>

      <!-- org name Column -->
      <ng-container matColumnDef="org_name">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          >Name</mat-header-cell
        >
        <mat-cell
          *matCellDef="let org"
          style="word-wrap: break-word; width: 20%; cursor: default"
          >{{ org.org_name }}</mat-cell
        >
      </ng-container>

      <!-- org type Column -->
      <ng-container matColumnDef="org_type">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          >Type</mat-header-cell
        >
        <mat-cell
          *matCellDef="let org"
          style="word-wrap: break-word; width: 20%; cursor: default"
          >{{ org.org_type }}</mat-cell
        >
      </ng-container>

      <!-- org contact email Column -->
      <ng-container matColumnDef="org_owner_email">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          >Contact Email</mat-header-cell
        >
        <mat-cell
          *matCellDef="let org"
          style="
            word-wrap: break-word;
            width: 20%;
            cursor: default;
            color: blue;
          "
          >{{ org.org_owner_email }}</mat-cell
        >
      </ng-container>

      <!-- org contact phone Column -->
      <ng-container matColumnDef="org_contact_phone">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          >Contact Phone</mat-header-cell
        >
        <mat-cell
          *matCellDef="let org"
          style="word-wrap: break-word; width: 20%; cursor: default"
          >{{ org.org_contact_phone }}</mat-cell
        >
      </ng-container>

      <!-- org status Column -->
      <ng-container matColumnDef="org_status">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          >Status</mat-header-cell
        >
        <mat-cell
          *matCellDef="let org"
          style="word-wrap: break-word; width: 20%; cursor: default"
          >{{ org.org_status }}</mat-cell
        >
      </ng-container>

      <!-- org status actions -->
      <ng-container matColumnDef="obj_view">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell
          *matCellDef="let obj"
          style="
            word-wrap: break-word;
            width: 20%;
            cursor: default;
            color: blue;
          "
        >
          <button
            mat-stroked-button
            (click)="setSelectedObj(obj); viewObj()"
            style="
              width: 0.8em;
              margin-left: 0.5em;
              margin-right: 0.4em;
              color: #2274a5;
            "
          >
            <mat-icon style="width: 0.8em; color: #2274a5">preview</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- org status actions -->
      <ng-container matColumnDef="obj_edit">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell
          *matCellDef="let obj"
          style="
            word-wrap: break-word;
            width: 20%;
            cursor: default;
            color: #2274a5;
          "
        >
          <button
            *ngif="obj.isObjAdmin || (obj.iam && userData.iam)"
            mat-stroked-button
            (click)="setSelectedObj(obj); editObj()"
            style="
              width: 0.8em;
              margin-left: 0.5em;
              margin-right: 0.4em;
              color: #2274a5;
            "
          >
            <mat-icon style="width: 0.8em; color: #2274a5">edit</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- org status actions -->
      <ng-container matColumnDef="obj_actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell
          *matCellDef="let obj"
          (click)="setSelectedObj(obj)"
          style="
            word-wrap: break-word;
            width: 20%;
            cursor: default;
            color: #2274a5;
          "
        >
          <button
            mat-stroked-button
            [matMenuTriggerFor]="rowMenu"
            [matMenuTriggerData]="{ obj: obj }"
            style="
              width: 0.8em;
              margin-left: 0.5em;
              margin-right: 0.4em;
              color: #2274a5;
            "
          >
            <mat-icon style="width: 0.8em; color: #1a567a">more_vert</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- org selector // (click)="setSelectedObj(obj)"	  -->
      <ng-container matColumnDef="obj_selector">
        <mat-header-cell *matHeaderCellDef>Selected</mat-header-cell>
        <mat-cell
          *matCellDef="let obj"
          style="
            word-wrap: break-word;
            width: 20%;
            cursor: default;
            color: #2274a5;
          "
        >
          <mat-checkbox
            class="example-margin"
            [checked]="selectedObj && obj.uid === selectedObj.uid"
            (change)="toggleChecked(obj)"
          ></mat-checkbox>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <mat-paginator
    #paginator
    [length]="0"
    [pageSizeOptions]="[7, 15, 25, 50, 75, 100]"
    [showFirstLastButtons]="true"
    (page)="onTableChangePage($event)"
  >
  </mat-paginator>
</div>
<!-- ORG_TABLE Template -->

<!-- Expand List Template -->

<div #orgExpandList *ngIf="template === DisplayTemplate.EXPAND_LIST">
  <mat-list>
    <div
      style="
        display: flex;
        flex-flow: row;
        justify-content: space-around;
        align-items: center;
      "
    >
      <mat-form-field
        *ngIf="showTitleFilter"
        class="mat-header-row"
        style="font-size: 0.75rem; margin-left: 2em; margin-right: 0.5em"
      >
        <input
          matInput
          #titleFilterInput
          [(ngModel)]="titleFilter"
          type="text"
          style="width: 60%; font-size: 1rem"
          placeholder="Enter Search filter"
        />
      </mat-form-field>
      <button
        *ngIf="showSelectButton"
        mat-stroked-button
        style="margin-top: -1em; background-color: #2274a5; color: white"
        (click)="onDone()"
      >
        Done
      </button>
      <button
        *ngIf="(showAddButton && isObjAdmin) || (iam && userData.iam)"
        mat-stroked-button
        style="margin-top: -1em; background-color: #2274a5; color: white"
        (click)="createObj()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div
      *ngFor="
        let grp of orgsvc.orgList$
          | async
          | filterkeys: ['org_name'] : titleFilter
          | sortkey: 'org_name' : 'asc'
      "
      style="display: flex; flex-flow: column; width: 100%"
    >
      <mat-divider style="min-width: 100%"></mat-divider>
      <app-org
        #objListItem
        style="width: 100%"
        [iam]="iam"
        [isObjAdmin]="isObjAdmin"
        [mode]="objMode"
        [userInfo]="userInfo"
        [userData]="userData"
        [showActions]="showActions"
        [useMenuActionDialog]="useMenuActionDialog"
        [objData]="grp"
        [selectedObj]="selectedObj"
        (modeEvent)="setMode($event)"
        (refreshEvent)="refreshList()"
        (selectObjEvent)="setSelectedObj($event)"
        (submitEvent)="onDone()"
        (cancelEvent)="onDone()"
      >
      </app-org>
      <mat-divider [inset]="true"></mat-divider>
    </div>
    <mat-divider style="color: gray; min-width: 100%"></mat-divider>
  </mat-list>
  <div class="list-bottom-div">
    <div class="list-btn-div">
      <button mat-stroked-button class="submit-btn" (click)="onDone()">
        Done
      </button>
    </div>
  </div>
</div>

<!-- Delete Template -->
<div #orgDelete *ngIf="template === DisplayTemplate.DELETE">
  <app-org
    #objDelFormItem
    style="width: 100%"
    [iam]="iam"
    [isObjAdmin]="isObjAdmin"
    [mode]="objMode"
    [userInfo]="userInfo"
    [userData]="userData"
    [objData]="selectedObj"
    [selectedObj]="selectedObj"
    (modeEvent)="setMode($event)"
    (prevEvent)="prevObj()"
    (nextEvent)="nextObj()"
    (refreshEvent)="refreshList()"
    (selectObjEvent)="setSelectedObj($event)"
    (deleteObjEvent)="refreshList()"
    (submitEvent)="onDone()"
    (cancelEvent)="onDone()"
  >
  </app-org>
</div>

<!--
</div> <!-- org-list component -->
